const domain = window.location.hostname;
const origin = window.location.origin;
let API_PATH = "";
let gcomUrl = "";
let toolUrl = "";
let INTERCOM_HELP_ROUTE = 'https://intercom.help/gartner-data-hub';
const APP_LOCAL_PATH = 'developer.gartner.com';

const envs = {
  dev: "development",
  qa: "qa",
  prod: "production",
};

export const getCurrentEnv = () => {
  if (domain.indexOf('toolsqa') !== -1) {
    return 'qa';
  }
  if (domain.indexOf('toolsdv') !== -1 || domain.indexOf('developer.gartner.com') !== -1) {
    return 'dev';
  }
  return 'prod';
};

const serviceEnv = process.env.SERVICE_ENV || envs.dev;

const gartnerUrls = {
  [envs.dev]: "https://gcom.pdodev.aws.gartner.com",
  [envs.qa]: "https://gcom.pdoqa.aws.gartner.com",
  [envs.prod]: "https://www.gartner.com",
};

const toolsUrls = {
  [envs.dev]: 'https://toolsdv.gartner.com',
  [envs.qa]: 'https://toolsqa.gartner.com',
  [envs.prod]: 'https://tools.gartner.com',
};

const GENIE_AUTH_ENV = {
  LOCAL: 'http://toolsdv.gartner.com/account/signin',
};

const hosts = {
  [envs.dev]:
    "tools.pdotoolsdev.aws.gartner.com, toolsdv.gartner.com, developer.gartner.com ,delphi.pdotoolsdev.aws.gartner.com",
  [envs.qa]:
    "tools.pdotoolsqa.aws.gartner.com, toolsqa.gartner.com, delphi.pdotoolsqa.aws.gartner.com",
};

// Local dev injects window.GARTNER_ENV ("dev" | "qa" | "prod") to mirror the
// upstream the dev-server proxy is pointing at; otherwise fall back to
// host-based detection (which is what actually runs in deployed envs).
let resolvedEnv;
if (typeof window !== "undefined" && envs[window.GARTNER_ENV]) {
  resolvedEnv = envs[window.GARTNER_ENV];
} else if (hosts[envs.dev].indexOf(domain) !== -1) {
  resolvedEnv = envs.dev;
} else if (hosts[envs.qa].indexOf(domain) !== -1) {
  resolvedEnv = envs.qa;
} else {
  resolvedEnv = envs.prod;
  INTERCOM_HELP_ROUTE = "https://tools.gartner.com/support-intercom";
}
gcomUrl = gartnerUrls[resolvedEnv];
toolUrl = toolsUrls[resolvedEnv];

// gcom is a different origin than the page (CORS + Secure-cookie issues from
// HTTPS dev), so in local dev route gcom API calls through the dev-server
// proxy at /__gcom (see delphi-root-app/webpack.config.js).
let gartnerApiUrl = gcomUrl;
if (domain.indexOf(APP_LOCAL_PATH) !== -1) {
  toolUrl = "";
  gartnerApiUrl = "/__gcom";
}

export const isProd = () => serviceEnv === envs.prod;

const config = {
  domain,
  origin,
  GARTNER_URL: gartnerApiUrl,
  API_PATH_TOOLS: toolUrl,
  INTERCOM_HELP_ROUTE,
  GENIE_AUTH_URL: GENIE_AUTH_ENV.LOCAL,
  APP_LOCAL_PATH,
  LOGOUT_EVENT_KEY: 'logout-event',
  TOKEN_KEY_INFO: 'genie_uid',
  GAP_ADMIN_IDENTIFIER: "x-api-key",
  USER_SESSION_IDENTIFIER: "userPromptSessionId",
  API_PATH: {
    LOGOUT: "/api/auth/logout",
    LOGIN: "/account/signin",
  },
  BASE_URL: "/data-hub",
  GENIE_AUTH_PARAMS: "&name=data-hub&version=1",
  S3_ASSET_PATH: `${toolUrl}/assets/common/data-hub`,
};

export default config;
